import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ClerkProvider, useAuth } from "@clerk/clerk-react";
import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import App from "./App";
import { ConfigMissing } from "./routes/ConfigMissing";
import { ViewAsProvider } from "./lib/view-as-context";
import "./index.css";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const CONVEX_URL = import.meta.env.VITE_CONVEX_URL;

const root = ReactDOM.createRoot(document.getElementById("root")!);

// Render an explicit configuration page when env is missing — keeps the
// dev server bootable so you can land on the app and see what's wrong,
// rather than a blank white screen with a console error.
if (!PUBLISHABLE_KEY || !CONVEX_URL) {
  root.render(
    <React.StrictMode>
      <ConfigMissing
        missing={[
          !PUBLISHABLE_KEY ? "VITE_CLERK_PUBLISHABLE_KEY" : null,
          !CONVEX_URL ? "VITE_CONVEX_URL" : null,
        ].filter((x): x is string => x !== null)}
      />
    </React.StrictMode>,
  );
} else {
  const convex = new ConvexReactClient(CONVEX_URL);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
          <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
            <ViewAsProvider>
              <App />
            </ViewAsProvider>
          </ConvexProviderWithClerk>
        </ClerkProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}
